(() => {
  const selectors = {
    container: '#rex-cnc-container',
    trigger: '#rex-cnc-stockinstore',
    search: '#rex-cnc-search',
    map: '#rex-cnc-map',
    results: '#rex-cnc-results',
  };

  function getPanelParts(container) {
    return [selectors.search, selectors.map, selectors.results]
      .map((selector) => container.querySelector(selector))
      .filter(Boolean);
  }

  function setExpanded(container, trigger, panel, expanded) {
    container.dataset.cncExpanded = expanded ? 'true' : 'false';
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    panel.hidden = !expanded;
  }

  function buildPanel(container) {
    let panel = container.querySelector('[data-rex-cnc-collapse-panel]');

    if (panel) return panel;

    const parts = getPanelParts(container);
    if (!parts.length) return null;

    panel = document.createElement('div');
    panel.id = 'rex-cnc-collapse-panel';
    panel.className = 'rex-cnc-collapse-panel';
    panel.setAttribute('data-rex-cnc-collapse-panel', '');

    parts[0].before(panel);
    parts.forEach((part) => panel.appendChild(part));

    return panel;
  }

  function initContainer(container) {
    if (!container || container.dataset.cncCollapseReady === 'true') return;

    const trigger = container.querySelector(selectors.trigger);
    const panel = buildPanel(container);

    if (!trigger || !panel) return;

    container.dataset.cncCollapseReady = 'true';
    trigger.setAttribute('aria-controls', panel.id);

    setExpanded(container, trigger, panel, false);

    trigger.addEventListener(
      'click',
      (event) => {
        const isExpanded = container.dataset.cncExpanded === 'true';

        if (isExpanded) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setExpanded(container, trigger, panel, false);
          return;
        }

        setExpanded(container, trigger, panel, true);
      },
      true
    );
  }

  function initVariantRefresh(container) {
    if (!container || container.dataset.cncVariantRefreshReady === 'true') return;

    const picker = container
      .closest('.shopify-section')
      ?.querySelector('block-variant-picker[data-section-id][data-product-id]');
    if (!picker) return;

    container.dataset.cncVariantRefreshReady = 'true';

    document.addEventListener(`variant:change:${picker.dataset.sectionId}:${picker.dataset.productId}`, () => {
      if (container.dataset.cncExpanded !== 'true') return;

      const trigger = container.querySelector(selectors.trigger);
      const panel = container.querySelector('[data-rex-cnc-collapse-panel]');
      if (trigger && panel) setExpanded(container, trigger, panel, false);
    });
  }

  function init() {
    document.querySelectorAll(selectors.container).forEach((container) => {
      initContainer(container);
      initVariantRefresh(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  new MutationObserver(init).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
